// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getSettingsCollection } from "@guestsupply/App/Store/Selectors/SettingsSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { connect } from "react-redux";

const enum fields {
    isNavigationList = "isNavigationList",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isNavigationList]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        paymentPortalLink: getSettingsCollection(state).customSettings?.paymentPortalLink,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface PaymentPortalLinkStyles {
    paymentLinkWrapper?: InjectableCss;
    paymentPortalLink?: LinkPresentationProps;
    navigationListLink?: LinkPresentationProps;
}

export const paymentPortalLink: PaymentPortalLinkStyles = {};

const styles = paymentPortalLink;

const PaymentPortalLink = ({ fields, paymentPortalLink }: Props) => {
    if (!paymentPortalLink) {
        return null;
    }

    return (
        <StyledWrapper {...(fields.isNavigationList ? null : styles.paymentLinkWrapper)}>
            <Link
                href={paymentPortalLink}
                target="_blank"
                {...(fields.isNavigationList ? styles.navigationListLink : styles.paymentPortalLink)}
            >
                {translate("Payment Portal")}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PaymentPortalLink),
    definition: {
        group: "Xngage Custom" as any,
        displayName: "Payment Portal Link",
        fieldDefinitions: [
            {
                name: fields.isNavigationList,
                displayName: "NavigationList Link",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
